import React, { FC, useState } from 'react'
import styled from 'styled-components'

const SubNavigatorWrapper = styled.div`
  display: flex;
  border-radius: 27px;
  background: ${({ theme }) => theme.subNavigatorBackgroundColor};
  padding: 7px;
  //   box-shadow: ${({ theme }) => theme.innerMediumShadow};

  span {
    flex: 1;
    border-radius: 17px;
    padding: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    &.selected {
      color: ${({ theme }) => theme.subNavigatorTextColorSelected};
      background: ${({ theme }) => theme.subNavigatorBackgroundColorSelected};
    }
    &:not(.selected) {
      color: ${({ theme }) => theme.subNavigatorBackgroundColorSelected};
      cursor: pointer;
    }
  }
`

// TODO: could be typed as a subset of string, such as OptionTab
export interface Props {
  options: string[]
  onChange: (option: string) => void
  selected: string
}

export const SubNavigator: FC<Props> = ({ options, onChange, selected }) => {
  return (
    <SubNavigatorWrapper className={'sub-selector-wrapper'}>
      {options.map((option, index) => {
        const first = index === 0
        const last = index === options.length - 1
        const classes = []
        if (selected === option) {
          classes.push('selected')
        }
        if (first) {
          classes.push('first')
        }
        if (last) {
          classes.push('last')
        }
        return (
          <span
            key={option}
            onClick={() => {
              if (option === selected) {
                return
              }
              onChange(option)
            }}
            className={classes.join(' ')}
          >
            {option}
          </span>
        )
      })}
    </SubNavigatorWrapper>
  )
}
